module.exports = __webpack_public_path__ + "media/fr_ca_s4_Thierry.9aeb55f0.mp3";